import React, { Component } from 'react';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import UI from '../../ui';
import ModalModule from '../../modal';
import Util from '../Util';

const { WrappedCheckbox, WrappedInputNumberWithLabel } = UI;
const { Modal, ModalContext, ModalButtonActionType } = ModalModule;

export default class ResetFieldModal extends Component {
	constructor(props) {
		super(props);

		const { data } = this.props;
		const { preferences = {} } = data;
		const [lbs = 0, oz = 0] = isString(preferences.resetFieldWeight)
			? this.convertPreferenceToNumber(preferences.resetFieldWeight)
			: [];
		const [length = 0, width = 0, height = 0] = isString(preferences.resetFieldDimensions)
			? this.convertPreferenceToNumber(preferences.resetFieldDimensions)
			: [];

		this.state = {
			resetFieldService: preferences.resetFieldService !== '0',
			resetFieldWeight: preferences.resetFieldWeight !== '0',
			resetFieldDimensions: preferences.resetFieldDimensions !== '0',
			resetFieldMailToAddress: preferences.resetFieldMailToAddress !== '0',
			resetFieldTracking: preferences.resetFieldTracking !== '0',
			resetFieldExtraServices: preferences.resetFieldExtraServices !== '0',
			resetFieldInsurance: preferences.resetFieldInsurance !== '0',
			resetFieldReferenceNumbers: preferences.resetFieldReferenceNumbers !== '0',
			resetFieldCostCode: preferences.resetFieldCostCode !== '0',
			resetFieldCustoms: preferences.resetFieldCustoms !== '0',
			resetFieldQuantity: preferences.resetFieldQuantity !== '0',
			resetFieldStampAmout: preferences.resetFieldStampAmout !== '0',
			autoAdvanceLabel: preferences.autoAdvanceLabel !== '0',
			lbs,
			oz,
			length,
			width,
			height,
		};
	}

	buildNewPreferences = () => {
		const {
			resetFieldService,
			resetFieldWeight,
			resetFieldDimensions,
			resetFieldMailToAddress,
			resetFieldTracking,
			resetFieldExtraServices,
			resetFieldInsurance,
			resetFieldReferenceNumbers,
			resetFieldCostCode,
			resetFieldCustoms,
			resetFieldQuantity,
			resetFieldStampAmout,
			autoAdvanceLabel,
			lbs,
			oz,
			length,
			width,
			height,
		} = this.state;

		return {
			resetFieldService: resetFieldService ? '1' : '0',
			resetFieldWeight: resetFieldWeight ? `${lbs}:${oz}` : '0',
			resetFieldDimensions: resetFieldDimensions ? `${length}:${width}:${height}` : '0',
			resetFieldMailToAddress: resetFieldMailToAddress ? '1' : '0',
			resetFieldTracking: resetFieldTracking ? '1' : '0',
			resetFieldExtraServices: resetFieldExtraServices ? '1' : '0',
			resetFieldInsurance: resetFieldInsurance ? '1' : '0',
			resetFieldReferenceNumbers: resetFieldReferenceNumbers ? '1' : '0',
			resetFieldCostCode: resetFieldCostCode ? '1' : '0',
			resetFieldCustoms: resetFieldCustoms ? '1' : '0',
			resetFieldQuantity: resetFieldQuantity ? '1' : '0',
			resetFieldStampAmout: resetFieldStampAmout ? '1' : '0',
			autoAdvanceLabel: autoAdvanceLabel ? '1' : '0',
		};
	};

	convertPreferenceToNumber = preference => preference.split(':').map(str => +str);

	onClickDone = () => {
		const { closeModal } = this.context;
		const {
			modalId,
			data: { closeCallback },
		} = this.props;
		const newPreferences = this.buildNewPreferences();

		// calls the callback function with new preferences values
		if (isFunction(closeCallback)) {
			closeCallback(newPreferences);
		}

		closeModal(modalId, ModalButtonActionType.Ok);
	};

	onChangeFieldCheckbox = ({ target: { name } }) => {
		const { [name]: value } = this.state;
		const { showError } = this.context;

		this.setState(prevState => ({ [name]: !prevState[name] }));

		Util.saveNewPreferences(
			{ [name]: value === '0' || value === false ? '1' : '0' },
			showError
		);
	};

	onChangeInputNumber = ({ target: { name, value = 0 } }) => {
		const {
			resetFieldWeight,
			resetFieldDimensions,
			lbs,
			oz,
			length,
			width,
			height,
		} = this.state;
		const { showError } = this.context;

		const prefName =
			name === 'lbs' || name === 'oz' ? 'resetFieldWeight' : 'resetFieldDimensions';
		const newLbs = name === 'lbs' ? value : lbs;
		const newOz = name === 'oz' ? value : oz;
		const newLength = name === 'length' ? value : length;
		const newWidth = name === 'width' ? value : width;
		const newHeight = name === 'height' ? value : height;
		const newResetFieldWeight = resetFieldWeight ? `${newLbs}:${newOz}` : '0';
		const newResetFieldDimensions = resetFieldDimensions
			? `${newLength}:${newWidth}:${newHeight}`
			: '0';

		this.setState({
			[name]: value,
		});

		Util.saveNewPreferences(
			{
				[prefName]:
					prefName === 'resetFieldWeight' ? newResetFieldWeight : newResetFieldDimensions,
			},
			showError
		);
	};

	render() {
		const { modalId } = this.props;
		const {
			resetFieldService,
			resetFieldWeight,
			resetFieldDimensions,
			resetFieldMailToAddress,
			resetFieldTracking,
			resetFieldExtraServices,
			resetFieldInsurance,
			resetFieldReferenceNumbers,
			resetFieldCostCode,
			resetFieldCustoms,
			resetFieldQuantity,
			resetFieldStampAmout,
			autoAdvanceLabel,
			lbs,
			oz,
			length,
			width,
			height,
		} = this.state;

		return (
			<Modal
				modalId={modalId}
				className="common-settings reset-fields-modal"
				header="Reset Fields"
				primaryButton={{
					type: ModalButtonActionType.OK,
					text: 'Done',
					dataqa: 'reset-fields-done-button',
					onClick: this.onClickDone,
				}}
			>
				<div className="p-grid p-dir-col">
					<p
						data-qa="settingsMailGeneral-resetFields-header"
						{...{ dataqa: 'settingsMailGeneral-resetFields-header' }}
					>
						Check which fields to reset after each print. Default values may be
						specified for certain fields.
					</p>
					<hr />
					<p>
						<b>Mailpiece Info</b>
					</p>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-service"
							className="inline-item"
							name="resetFieldService"
							checked={resetFieldService}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-service"
						>
							Service
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-weight"
							className="inline-item"
							name="resetFieldWeight"
							checked={resetFieldWeight}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-weight"
						>
							Weight
						</WrappedCheckbox>
						<WrappedInputNumberWithLabel
							label="Lbs:"
							name="lbs"
							className={`${resetFieldWeight ? '' : 'disabled'}`}
							uiElementConfig={{
								value: lbs,
								min: 0,
								name: 'lbs',
								dataqa: 'settingsMailGeneral-resetFields-weightLbs',
								onChange: this.onChangeInputNumber,
								disabled: !resetFieldWeight,
							}}
						/>
						<WrappedInputNumberWithLabel
							label="oz:"
							name="oz"
							className={`${resetFieldWeight ? '' : 'disabled'}`}
							uiElementConfig={{
								value: oz,
								name: 'oz',
								dataqa: 'settingsMailGeneral-resetFields-weightOz',
								min: 0,
								minFractionDigits: 2,
								onChange: this.onChangeInputNumber,
								disabled: !resetFieldWeight,
							}}
						/>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-dimensions"
							className="inline-item"
							name="resetFieldDimensions"
							checked={resetFieldDimensions}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-dimensions"
						>
							Dimensions
						</WrappedCheckbox>
						<WrappedInputNumberWithLabel
							label="L:"
							className={`${resetFieldDimensions ? '' : 'disabled'}`}
							uiElementConfig={{
								value: length,
								name: 'length',
								dataqa: 'settingsMailGeneral-resetFields-length',
								min: 0,
								minFractionDigits: 2,
								onChange: this.onChangeInputNumber,
								disabled: !resetFieldDimensions,
							}}
						/>
						<WrappedInputNumberWithLabel
							label="W:"
							className={`${resetFieldDimensions ? '' : 'disabled'}`}
							uiElementConfig={{
								value: width,
								name: 'width',
								dataqa: 'settingsMailGeneral-resetFields-width',
								min: 0,
								minFractionDigits: 2,
								onChange: this.onChangeInputNumber,
								disabled: !resetFieldDimensions,
							}}
						/>
						<WrappedInputNumberWithLabel
							label="H:"
							className={`${resetFieldDimensions ? '' : 'disabled'}`}
							uiElementConfig={{
								value: height,
								name: 'height',
								dataqa: 'settingsMailGeneral-resetFields-height',
								min: 0,
								minFractionDigits: 2,
								onChange: this.onChangeInputNumber,
								disabled: !resetFieldDimensions,
							}}
						/>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-mail-to-address"
							className="inline-item"
							name="resetFieldMailToAddress"
							checked={resetFieldMailToAddress}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-shipToAddresses"
						>
							Ship to Addresses (including Email)
						</WrappedCheckbox>
					</div>
					<hr />
					<p>
						<b>Additional Options</b>
					</p>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-tracking"
							className="inline-item"
							name="resetFieldTracking"
							checked={resetFieldTracking}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-tracking"
						>
							Tracking
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-extra-services"
							className="inline-item"
							name="resetFieldExtraServices"
							checked={resetFieldExtraServices}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-extraServices"
						>
							Extra Services
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-insurance"
							className="inline-item"
							name="resetFieldInsurance"
							checked={resetFieldInsurance}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-insurance"
						>
							Insurance
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-references-numbers"
							className="inline-item"
							name="resetFieldReferenceNumbers"
							checked={resetFieldReferenceNumbers}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-referenceNumbers"
						>
							Reference Numbers
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-cost-code"
							className="inline-item"
							name="resetFieldCostCode"
							checked={resetFieldCostCode}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-costCode"
						>
							Cost Code
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-customs"
							className="inline-item"
							name="resetFieldCustoms"
							checked={resetFieldCustoms}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-customs"
						>
							Customs
						</WrappedCheckbox>
					</div>
					<hr />
					<p>
						<b>Other</b>
					</p>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-quantity"
							className="inline-item"
							name="resetFieldQuantity"
							checked={resetFieldQuantity}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-quantity"
						>
							Quantity
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-reset-field-stamp-amout"
							className="inline-item"
							name="resetFieldStampAmout"
							checked={resetFieldStampAmout}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-stampsAmount"
						>
							Stamps Amount (NetStamps)
						</WrappedCheckbox>
					</div>
					<div className="settings-row p-col-12">
						<WrappedCheckbox
							inputId="settings-auto-advance-label"
							className="inline-item"
							name="autoAdvanceLabel"
							checked={autoAdvanceLabel}
							onChange={this.onChangeFieldCheckbox}
							dataqa="settingsMailGeneral-resetFields-autoAdvance"
						>
							Auto-Advance Label Position (NetStamps and Label Sheets)
						</WrappedCheckbox>
					</div>
				</div>
			</Modal>
		);
	}
}

ResetFieldModal.contextType = ModalContext;
